import _omit from 'lodash/omit';

import {
  ACTION_LOAD_AFFILIATE_TOOL_CONTENT__REQUEST,
  ACTION_LOAD_AFFILIATE_TOOL_CONTENT__SUCCESS,
  ACTION_LOAD_AFFILIATE_TOOL_CONTENT__FAIL,
} from '../../actionTypes';


export default (state = {}, action) => {
  switch (action.type) {
    case ACTION_LOAD_AFFILIATE_TOOL_CONTENT__REQUEST:
    case ACTION_LOAD_AFFILIATE_TOOL_CONTENT__SUCCESS:
      return _omit(state, action.payload.id);

    case ACTION_LOAD_AFFILIATE_TOOL_CONTENT__FAIL: {
      const { id, error } = action.payload;

      return { ...state, [id]: error };
    }

    default:
      return state;
  }
};
